import CustomTable from "components/common/CustomTable";
import SynthTooltip from "components/common/SynthTooltip";
import VendorAvatar from "components/common/VendorAvatar";
import { formatMoney, getCurrencyFromCurrencyCode } from "helpers";
import { camelCaseToRegularCase } from "helpers/camelCaseToRegularCase";
import React, { useEffect, useState } from "react";

type UpdateProductProps = {
    resultMessage: {
        message: string;
        products: Record<string, any>;
        success: boolean;
    };
    toolName: string;
};

const UpdateProduct = ({ resultMessage, toolName }: UpdateProductProps) => {

    const [headers, setHeaders] = useState<any[]>([]);

    useEffect(() => {
        if (resultMessage?.products?.length > 0) {
            const tableHeaders = resultMessage?.products?.map((item) => {
                return item?.updatedFields;
            });
            setHeaders(Object.assign({}, ...tableHeaders));
        }
    }, [resultMessage]);


    const tableHeader = [
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Product name
                    </span>
                </div>
            ),
            widthClass: "w-[180px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">SKU No. </span>
                </div>
            ),
            widthClass: "w-[180px] !border-r-none",
        },
        {
            title: (
                <div className="flex space-x-1.5 items-center">
                    <span className="text-xs font-rocGroteskMedium text-slate-700">
                        Current stock level
                    </span>
                </div>
            ),
            widthClass: "w-[150px] !border-r-none",
        },
        ...(Object.keys(headers || {}).length > 0
            ? Object.keys(headers || {}).flatMap((key) => {
                  return [
                      {
                          title: (
                              <div className="flex space-x-1.5 items-center">
                                  <span className="text-xs font-rocGroteskMedium text-slate-700">
                                      {`Old ${
                                          key === "isProductPerishable"
                                              ? "Perishability Status"
                                              : key === "vendorIds" || key === "vendors"
                                              ? "Suppliers"
                                              : camelCaseToRegularCase(key)
                                      }`}
                                  </span>
                              </div>
                          ),
                          widthClass: "w-[180px] ",
                      },
                      {
                          title: (
                              <div className="flex space-x-1.5 items-center">
                                  <span className="text-xs font-rocGroteskMedium text-slate-700">
                                      {`New ${
                                          key === "isProductPerishable"
                                              ? "Perishability Status"
                                              : key === "vendorIds" || key === "vendors"
                                              ? "Suppliers"
                                              : camelCaseToRegularCase(key)
                                      }`}
                                  </span>
                              </div>
                          ),
                          widthClass: "w-[180px] ",
                      },
                  ];
              })
            : []),
    ];
    const tableBody = resultMessage?.products?.map((item, idx) => {
        return [
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-3">
                                {item?.productUpdated?.productImageDetails?.productImages?.[0] ? (
                                    <VendorAvatar
                                        imageSrc={
                                            item?.productUpdated?.productImageDetails
                                                ?.productAvatar ||
                                            item?.productUpdated?.productImageDetails
                                                ?.productImages?.[0]
                                        }
                                        size={32}
                                        name={item?.productUpdated?.productName}
                                        containerClassname="!rounded-md"
                                    />
                                ) : (
                                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200 ">
                                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                                    </div>
                                )}
                                <p className="text-sm">{item?.productUpdated?.productName || ""}</p>
                            </div>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2 break-all`}
                    >
                        <div>
                            <p className="text-slate-500 text-sm ">
                                {item?.productUpdated?.sku || "N/A"}
                            </p>
                        </div>
                    </div>
                ),
            },
            {
                content: (
                    <div
                        key={idx}
                        className={`!font-rocGroteskMedium border-slate-100 text-sm text-g-75 py-2`}
                    >
                        <p className="">
                            {item?.productUpdated?.productStockDetails?.stockLevel
                                ? `${formatMoney()?.format(
                                      item?.productUpdated?.productStockDetails?.stockLevel ?? 0
                                  )} ${
                                      item?.productUpdated?.productStockDetails
                                          ?.unitOfMeasurement || ""
                                  }`
                                : "N/A"}
                        </p>
                    </div>
                ),
            },
            ...(Object.keys(headers || {}).length > 0
                ? Object.keys(headers || {}).flatMap((key) => {
                      return [
                          {
                              content: (
                                  <div key={idx}>
                                      {item?.updatedFields?.[key]
                                          ? `${
                                                typeof item?.previousProduct?.[key] === "boolean"
                                                    ? `${
                                                          item?.previousProduct?.[key]
                                                              ? "True"
                                                              : "False"
                                                      }`
                                                    : typeof item?.previousProduct?.[key] ===
                                                      "string"
                                                    ? item?.previousProduct?.[key]
                                                    : item?.previousProduct?.[key] ===
                                                          "salesPrice" ||
                                                      item?.previousProduct?.[key] === "unitCost"
                                                    ? `${getCurrencyFromCurrencyCode(
                                                          item?.previousProduct?.[key]?.currency
                                                      )} ${formatMoney()?.format(
                                                          item?.previousProduct?.[key]?.amount
                                                      )}`
                                                    : key === "vendorIds" || key === "vendors"
                                                    ? item?.previousProduct?.[key]
                                                          ?.map((vendor) => vendor?.vendorName)
                                                          ?.join(", ")
                                                    : "N/A"
                                            }`
                                          : "---"}
                                  </div>
                              ),
                          },
                          {
                              content: (
                                  <div key={idx}>
                                      {item?.updatedFields?.[key]
                                          ? `${
                                                typeof item?.productUpdated?.[key] === "boolean"
                                                    ? `${
                                                          item?.productUpdated?.[key]
                                                              ? "True"
                                                              : "False"
                                                      }`
                                                    : typeof item?.productUpdated?.[key] ===
                                                      "string"
                                                    ? item?.productUpdated?.[key]
                                                    : key === "salesPrice" || key === "unitCost"
                                                    ? `${getCurrencyFromCurrencyCode(
                                                          item?.productUpdated?.[key]?.currency
                                                      )} ${formatMoney()?.format(
                                                          item?.productUpdated?.[key]?.amount
                                                      )}`
                                                    : key === "vendorIds" || key === "vendors"
                                                    ? item?.productUpdated?.[key]
                                                          ?.map((vendor) => vendor?.vendorName)
                                                          ?.join(", ")
                                                    : "N/A"
                                            }`
                                          : "---"}
                                  </div>
                              ),
                          },
                      ];
                  })
                : []),
        ];
    });
    return (
        <div>
            {resultMessage?.success && resultMessage?.products?.length > 0 && (
                <CustomTable
                    tableBody={tableBody}
                    tableHeader={tableHeader}
                    isCellBordered={true}
                    stickyHeader={true}
                    headerContainerClass="!bg-slate-50 "
                    headerItemClass="font-rocGroteskMedium "
                    tableClass="mb-4"
                    isScrollable={true}
                    scrollWithin={true}
                    renderEmptyTable={() => null}
                />
            )}
        </div>
    );
};

export default UpdateProduct;
